import { WithdrawalSettlementDto } from '@/features/dashboard/bookingChanges/types/dto/WithdrawalDto.ts';
import { RefundChannel } from '@/features/dashboard/bookingChanges/types/dto/WithdrawalDto.ts';

/** Napisy okna rezygnacji. */

export const WITHDRAWAL_TITLE = 'Rezygnacja uczestnika';

/**
 * Rezygnacja omija szkic i akceptację — backend zakłada paczkę i od razu ją
 * wprowadza. Operator ma to wiedzieć, zanim kliknie, a nie po.
 */
export const WITHDRAWAL_INTRO =
  'Rezygnacja wchodzi w życie od razu: pozycje uczestnika znikają z rachunku, a raty przeliczają się na nowo. Cofnąć ją może tylko nowa paczka zmian.';

export const WITHDRAWAL_NO_SELECTION =
  'Zaznacz osoby, które rezygnują — rozliczenie policzy się samo.';

/** Zdanie nad rozliczeniem: czy odchodzi cała rezerwacja, czy jej część. */
export const settlementScopeSentence = (
  settlement: WithdrawalSettlementDto,
): string =>
  settlement.total
    ? 'Rezygnują wszyscy uczestnicy, więc rezerwacja zostaje zamknięta w całości.'
    : 'Rezerwacja zostaje z pozostałymi uczestnikami; poniżej rozliczenie odchodzących.';

export const REFUND_CHANNEL_LABELS: Record<RefundChannel, string> = {
  [RefundChannel.TRANSFER]: 'Przelew',
  [RefundChannel.CASH]: 'Gotówka',
  [RefundChannel.TPAY]: 'Płatność online',
};

export const getRefundChannelLabel = (channel: RefundChannel): string =>
  REFUND_CHANNEL_LABELS[channel];

/**
 * Etykiety wierszy rozliczenia. Zwrot i dopłata nie nazywają strony: pieniądze
 * zawsze idą przez zapisującego, a pełna nazwa łamie wiersz w wąskim panelu.
 */
export const SETTLEMENT_LABELS = {
  share: 'Udział odchodzących',
  fee: 'Potrącenie',
  paid: 'Wpłacono',
  liabilityAfter: 'Należność po rezygnacji',
  refund: 'Do zwrotu',
  debt: 'Do dopłaty',
} as const;

export const JUSTIFICATION_HINT =
  'Trafi do historii rezerwacji — wymagane przy rezygnacji.';

export const FEE_HINT =
  'Kwota, którą organizator zatrzymuje. Zostaw puste, jeśli nic nie potrącacie.';
